export class UserDropdownModel {
  public userId: number;
  public name: string;
  public phone: string;
  public regionId: number;
  public roleId: number;
}